var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17188 4.5L8.51562 2.15625C8.82031 1.875 8.82031 1.40625 8.51562 1.125L8 0.609375C7.71875 0.304688 7.25 0.304688 6.96875 0.609375L4.625 2.95312L2.25781 0.609375C1.97656 0.304688 1.50781 0.304688 1.22656 0.609375L0.710938 1.125C0.40625 1.40625 0.40625 1.875 0.710938 2.15625L3.05469 4.5L0.710938 6.86719C0.40625 7.14844 0.40625 7.61719 0.710938 7.89844L1.22656 8.41406C1.50781 8.71875 1.97656 8.71875 2.25781 8.41406L4.625 6.07031L6.96875 8.41406C7.25 8.71875 7.71875 8.71875 8 8.41406L8.51562 7.89844C8.82031 7.61719 8.82031 7.14844 8.51562 6.86719L6.17188 4.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8c2a2ed246395a3664e47c14c67178cd.svg";
export { ForwardRef as ReactComponent };